import { useCallback } from 'react';
import { Form, FormActions, message } from 'ui';
import { type ExtendedInvitationsFormValues, InvitationsFormContent } from '../../../../../invitations-form-content';
import { useAddEventDistributionListMutation, useAddEventParticipantsMutation } from '../../../../../queries';
import { useGetInvitationsRequestData } from './hooks';

type InvitationsFormValues = ExtendedInvitationsFormValues;

type P = {
  eventId: string;
  eventInviteesCount: number;
  onClose: () => void;
};

const SendInvitationsModalContent = ({ eventId, eventInviteesCount, onClose }: P) => {
  const { isPending: isAddingDistributionList, mutateAsync: addDistributionList } =
    useAddEventDistributionListMutation();
  const { isPending: isAddingParticipants, mutateAsync: addParticipants } = useAddEventParticipantsMutation();
  const getInvitationsRequestData = useGetInvitationsRequestData();

  const submit = useCallback(
    async (formValues: InvitationsFormValues) => {
      const { distributionList, participants } = getInvitationsRequestData(formValues);

      // TODO: Consider using Promise.allSettled and handling individual errors.
      await Promise.all([
        distributionList.length > 0 ? addDistributionList({ distributionList, eventId }) : Promise.resolve(),
        participants.length > 0 ? addParticipants({ eventId, participants }) : Promise.resolve(),
      ]);

      message.success('Invitations sent successfully');
      onClose();
    },
    [addDistributionList, addParticipants, eventId, getInvitationsRequestData, onClose],
  );

  return (
    <Form<InvitationsFormValues> onFinish={submit}>
      <InvitationsFormContent<InvitationsFormValues> alreadyInvitedCount={eventInviteesCount} isRequired />
      <FormActions
        right={{
          children: 'Back',
          onClick: onClose,
        }}
        submit={{ children: 'Send', loading: isAddingDistributionList || isAddingParticipants }}
      />
    </Form>
  );
};

export default SendInvitationsModalContent;
